import React, { useState } from 'react';
import { signInWithEmail } from '../services/firebase';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { accessDenied, deniedMessage, logout } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Please enter email and password'); return; }
    setLoading(true);
    setError(null);
    try {
      await signInWithEmail(email, password);
    } catch (err) {
      const map = {
        'auth/user-not-found': 'Invalid email or password',
        'auth/wrong-password': 'Invalid email or password',
        'auth/invalid-credential': 'Invalid email or password',
        'auth/invalid-email': 'Invalid email address',
        'auth/too-many-requests': 'Too many failed attempts. Please try again later.',
      };
      setError(map[err.code] || 'Failed to sign in. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = async () => { await logout(); setError(null); setEmail(''); setPassword(''); };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">
            <svg viewBox="0 0 24 24" fill="white" width="28" height="28">
              <path d="M3 20 L12 4 L22 4 L22 10 L14.5 10 L8.5 20Z" />
            </svg>
          </div>
          <h1>Hightag</h1>
          <p className="login-subtitle">GPS Analysis Suite</p>
        </div>

        {accessDenied ? (
          <div className="login-denied">
            <div className="denied-badge">Access Denied</div>
            <p>{deniedMessage || 'Your account is not authorized to access this application.'}</p>
            <p className="denied-hint">Contact an administrator to request access.</p>
            <button className="login-btn secondary" onClick={handleTryAgain}>
              Try a Different Account
            </button>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            {error && <div className="login-error">{error}</div>}
            <div className="field">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com" disabled={loading} autoComplete="email" />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password" disabled={loading} autoComplete="current-password" />
            </div>
            <button type="submit" className="login-btn primary" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
